// The AI sparkle on every Ask button (Gary, 3 Nov 2026), the same mark as CMB Chats, in CleanMyBed violet.
export function AskSparkle() {
  return (
    <svg className="ask-sparkle" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z" />
      <path d="M18.5 15l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8z" />
    </svg>
  );
}
